import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ImagemSun from 'assets/img/acessibilidade-sun.png';
import ImagemMoon from 'assets/img/acessibilidade-moon.png';
import ImagemCor from 'assets/img/acessibilidade-color.png';
import ImagemContraste from 'assets/img/acessibilidade-contrast.png';
import { fetchStatusModalCor, fetchUpdateTheme } from 'store/fetchActions/fetchApp';
import Tooltip from 'components/Tooltip/index';
import { ENUM_THEME, STORAGE_THEME_CUSTOM_FAS } from 'utils/consts';
import * as S from './../styles';
import { altIconeContraste, altIconePaleta, altIconeTema } from 'utils/acessibilidade';

export const ThemeSefaz = () => {
  const dispatch = useDispatch();

  const themeSelected = useSelector(state => state?.app?.theme);
  const idNameDarkTheme = 'dark-theme';
  const idNameContrasteTheme = 'contraste-theme';

  const [nameImage, setNameImage] = React.useState(ImagemMoon);

  React.useEffect(() => {
    if (themeSelected === ENUM_THEME.DARK) {
      alterarTema();
    }
    if (themeSelected === ENUM_THEME.CONTRAST) {
      alterarContraste();
    }
    if (themeSelected === ENUM_THEME.CUSTOM) {
      const listCustomColor = JSON.parse(localStorage.getItem(STORAGE_THEME_CUSTOM_FAS)) || {};
      Object.keys(listCustomColor).forEach(key => {
        document.body.style.setProperty(key, listCustomColor[key]);
        document.documentElement.style.setProperty(key, listCustomColor[key]);
      });
    }
    // eslint-disable-next-line
  }, [dispatch]);

  const alterarTema = () => {
    localStorage.removeItem(STORAGE_THEME_CUSTOM_FAS);
    const theme = document.body.classList.toggle(idNameDarkTheme);
    if (document.body.classList.contains(idNameContrasteTheme)) {
      document.body.classList.remove(idNameContrasteTheme);
    }
    setNameImage(theme ? ImagemSun : ImagemMoon);
    dispatch(fetchUpdateTheme(theme ? ENUM_THEME.DARK : ENUM_THEME.LIGHT));
  };

  const alterarContraste = () => {
    localStorage.removeItem(STORAGE_THEME_CUSTOM_FAS);
    const isContrast = document.body.classList.toggle(idNameContrasteTheme);
    if (document.body.classList.contains(idNameDarkTheme)) {
      document.body.classList.remove(idNameDarkTheme);
    }
    setNameImage(ImagemMoon);
    dispatch(fetchUpdateTheme(isContrast ? ENUM_THEME.CONTRAST : ENUM_THEME.LIGHT));
  };

  return (
    <S.ContainerAcessibilidade>
      <Tooltip text="Ativar tema escuro/claro" placement="bottomLeft">
        <S.IconAcessibilidade
          src={nameImage}
          alt={altIconeTema(nameImage === ImagemSun)}
          aria-label="Ativar ou desativar Tema escuro"
          onClick={() => alterarTema()}
          className={`acessibity-icon ${themeSelected === ENUM_THEME.DARK ? 'select' : ''}`}
        />
      </Tooltip>
      <Tooltip text="Personalizar cores" placement="bottomLeft">
        <S.IconAcessibilidade
          src={ImagemCor}
          alt={altIconePaleta}
          aria-label="Abrir paleta de cores do sistema"
          onClick={() => dispatch(fetchStatusModalCor(true, 'Alterar Cor'))}
          className={`acessibity-icon ${themeSelected === ENUM_THEME.CUSTOM ? 'select' : ''}`}
        />
      </Tooltip>
      <Tooltip text="Ativar contraste" placement="bottomLeft">
        <S.IconAcessibilidade
          src={ImagemContraste}
          alt={altIconeContraste}
          aria-label="Ativar ou desativar Alto contraste"
          onClick={alterarContraste}
          className={`acessibity-icon ${themeSelected === ENUM_THEME.CONTRAST ? 'select' : ''}`}
        />
      </Tooltip>
    </S.ContainerAcessibilidade>
  );
};
export default ThemeSefaz;
